// Site key
const siteKey = '6LdwAocdAAAAAG6OtMlZL1KUOiyaAvO-Tg_y42Qw';
export default siteKey;

